import { Component, OnInit, Input, ElementRef, ViewChild, Output, NgZone } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { Events, ModalController, NavController, Platform } from '@ionic/angular';
import { UserService } from 'src/app/services/user/user.service';
import { Storage } from '@ionic/storage';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { CartService } from 'src/app/services/cart/cart.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { ProductService } from 'src/app/services/product/product.service';
import { BrandsService } from 'src/app/services/brands/brands.service';
import { ServicesFeatureService } from 'src/app/services/services-feature/services-feature.service';
import { RegionModalPage } from 'src/app/pages/region-modal/region-modal.page';
import { SharedService } from 'src/app/services/shared/shared.service';
import { EventEmitter } from '@angular/core';
import { WalletService } from 'src/app/services/wallet/wallet.service';
import { SelectLanguagePage } from 'src/app/pages/select-language/select-language.page';
import { DeliverySettingsService } from 'src/app/services/delivery-settings/delivery-settings.service';
import { encodeURL } from 'src/app/services/parseURL';
import { ProductSubscriptionsService } from 'src/app/services/product-subscriptions/product-subscriptions.service';
import { PickDropService } from 'src/app/services/pick-drop/pick-drop.service';
import { ThemeService } from 'src/app/services/theme/theme.service';
import { VendorService } from 'src/app/services/vendor/vendor.service';
import { ChatBotPage } from 'src/app/chat-bot/chat-bot.page';
import { HeaderUtilsService } from '../header-utils.service';


@Component({
  selector: 'app-header-default',
  templateUrl: './header-default.component.html',
  styleUrls: ['./header-default.component.scss'],
})
export class HeaderDefaultComponent implements OnInit {
  @Input() backButton: boolean;
  @Input() innerPage: boolean;
  @Input() region: any;
  @Input() widgetPage: boolean;
  @Output() openRegionModalEvent = new EventEmitter();
  @Input() stickyHeader: boolean;
  @Output() getStickyHeightEvent = new EventEmitter();


  @ViewChild('searchContainer', {
      static: false
  }) searchContainer;


  displayMobileearch = false;
  loginStatus = false;
  categories: any[] = [];
  searchText = '';
  typingTimer;
  doneTypingInterval = 1000;
  showSearchLoader: boolean = false;
  showNoProducts = false;
  algoliaProducts: any[] = [];
  noMoreProducts: boolean = false;
  isPriceReq: boolean;
  showPrices: boolean;
  role: string;
  userId: string = '';
  page: number = 0;
  displaySearchResult;
  searchsubscribed: boolean = false;
  cartLength = 0;
  cartTotalPrice: number = 0;
  storeInfo;

  storeData: any = {
      allowComment: false,
      allowStoreInfo: false,
      appPackageName: "",
      appVersion: "",
      commentMsg: "",
      facebookUrl: "",
      instagramUrl: "",
      storeAddress: {
          address: "",
          city: "",
          state: "",
          stateCode: ""
      },
      storeInfo: "",
      storeName: "storeName",
      storePhone: "",
      twitterUrl: "",
      welcomeMsg: "",
      youtubeUrl: ""
  };
  isOpenSearch;
  cartSub: Subscription;
  priceForRetail = false;
  currencyCode: any;
  /* multiRegion = false;
   regions = [];
   region = {
       id: '',
       name: '',
       pincode: null
   }*/
  categoriesMenu;
  brandsMenu;
  servicesMenu;
  isWalletActive: boolean = false;
  RFQFeature = false;
  isMembership = false;
  subscriptionFeature = false;
  freeDeliverAmt = 0;
  activeMenu;
  showMenu:boolean = false;
  hideMenu = false;
  stickyHeight = 150;
  pickDropActive = false;
  themeSetting;
  isIOS;
  userPlace: { place: string; lat: any; lng: any; };
    cartProducts = []
  constructor(private router: Router, private events: Events,
      private storage: Storage,
      private themeService: ThemeService,
      private elementRef: ElementRef,
      private modalController: ModalController,
      private ngZone: NgZone,
      public userService: UserService,
      private cartService: CartService,
      private utilsService: UtilsService,
      private productService: ProductService,
      private brandsService: BrandsService,
      private servicesFeatureService: ServicesFeatureService,
      private sharedService: SharedService,
      private walletService: WalletService,
      private activatedRoute: ActivatedRoute,
      private deliverySettingsService: DeliverySettingsService,
      private configService: ConfigService,
      private platform: Platform,
      private productSubscriptionsService: ProductSubscriptionsService,
      private pickDropService: PickDropService,
      private vendorService: VendorService,
      private headerUtilsService:HeaderUtilsService,
      private navCtrl: NavController,) { }

  onClickDocument(event) {
      if (!this.searchContainer.nativeElement.contains(event.target)) { // or some similar check
          this.ngZone.run(() => {
              this.displaySearchResult = false;
          });
      }
  }

  openRegionModal(type) {
      this.openRegionModalEvent.emit(type);
  }

  closeMenu(){
      this.showMenu = false;
  }

  toggleMenu(){
      this.showMenu = !this.showMenu;
  }


  getActiveMenu() {
      let categoryId = this.activatedRoute.snapshot.paramMap.get('c_id');
      let subCatId = this.activatedRoute.snapshot.paramMap.get('s_c_id');
      if (subCatId) {
          this.activeMenu = subCatId;
      } else {
          this.activeMenu = categoryId;
      }
  }


  async ngOnInit() {
      this.platform.ready().then(() => {
          this.isIOS = this.platform.is('ios');
      });
      this.getStickyHeightEvent.emit(this.stickyHeight)
      this.getActiveMenu();

      let DeliveryData: any = await this.deliverySettingsService.getDeliverySettingsDataInSessionStorage();
      if ((Object.keys(DeliveryData).length)) {
          this.freeDeliverAmt = DeliveryData.freeDeliveryAmt;
      }


      let storeData: any = await this.storage.get('storeInfo');
      if (storeData) {
          this.storeData = storeData;
      }

      this.categoriesMenu = await this.productService.getCategoriesWithSubcategoriesForMenu();
      console.log('this.categoriesMenu', this.categoriesMenu);
      this.brandsMenu = await this.brandsService.getAllBrandsForSideMenu();
      this.servicesMenu = await this.servicesFeatureService.getServicesForMenu();
      



      setTimeout(() => {
          this.initializeSubscriptions();
      }, 1000);
      setTimeout(async () => {
          this.categoriesMenu = await this.productService.getCategoriesWithSubcategoriesForMenu();
          this.brandsMenu = await this.brandsService.getAllBrandsForSideMenu();
          this.servicesMenu = await this.servicesFeatureService.getServicesForMenu();
          this.initializeSubscriptions();
      }, 2000);

      this.initializeSubscriptions();
      this.storage.get('uid').then((val) => {
          this.userId = val;
      });
      this.priceRequestFeature();

      this.cartProducts = this.cartService.getCartProducts();
      this.cartLength = this.cartProducts.length;
      this.cartTotalPrice = this.cartService.getCartPrice(this.cartProducts);

      this.RFQFeature = this.configService.environment.RFQFeature;
      this.priceForRetail = this.configService.environment.priceForRetail;
      this.currencyCode = this.configService.environment.currencyCode;
      this.isOpenSearch = this.configService.environment.openAlgoliaSearch;
      //this.multiRegion = this.configService.environment.multiRegion;
      this.role = await this.storage.get('userRole');
      this.storeInfo = await this.storage.get('storeInfo');
      this.isMembership = this.configService.environment.membership;
      if (this.configService.environment.subscriptionFeature) {
          const subSettings: any = await this.productSubscriptionsService.getSettings('return');
          this.subscriptionFeature = subSettings && subSettings.isActive ? true : false;
      }
      const walletSettings: any = await this.walletService.getWalletSettings('sidemenu');
      this.isWalletActive = walletSettings && walletSettings.active ? walletSettings.active : false;


      let userId = this.userService.getUserId();
      if (userId === '') {
          this.loginStatus = false;
      } else {
          this.loginStatus = true;
      }

      await this.checkVendorSettingsForLocation();

      this.vendorService.userPlaceSub.subscribe(place => {
          this.userPlace = place;
      });


      /* if (this.multiRegion && this.role === 'user') {
         this.events.publish('multi-region:getActiveStatus');
         console.log('publish multi-region:getActiveStatus')
     }*/
  }

  /* async checkUserRegion() {
     const region: any = await this.sharedService.getStorageRegion();
     console.log('region', region);
     if (!region || region === undefined) {
         this.openRegionModal('not_close');
     } else {
         if ((this.regions.findIndex(r => r.id === region.id)) === -1) {
             this.openRegionModal('region_deleted')
         } else {
             this.region = region;
         }
     }
 }*/

  //  async openRegionModal(type) {
  //       const modal = await this.modalController.create({
  //           component: RegionModalPage,
  //           cssClass: 'custom-modal login-modal',
  //           backdropDismiss: type === 'close' ? true : false,
  //           componentProps: {
  //               regions: this.regions,
  //               closeIcon: type === 'close' ? true : false,
  //               isRegionDeleted: type === 'region_deleted' ? true : false
  //           }
  //       });

  //       modal.onDidDismiss().then((region: any) => {
  //           if (region.data) {
  //               this.region = region.data;
  //               this.events.publish('product:getAllCategoriesForShop');
  //               this.events.publish('brands:getAllBrandsForUser');
  //               this.events.publish('services-feature:getAllServicesForHome');
  //           }
  //       });
  //       await modal.present();
  //   }


  toggleMobileSearch() {
      if (this.displayMobileearch == false) {
          this.displayMobileearch = true;
      } else {
          this.displayMobileearch = false;
      }
      //// console.log(this.displayMobileearch)
  }
  priceRequestFeature() {
      this.isPriceReq = this.configService.environment.priceReqFeature;
      if (this.isPriceReq) {
          this.storage.get('showPrices').then((val) => {
              this.showPrices = val;
              this.storage.get('userRole').then((role) => {
                  this.role = role;
              });
          });
      }
  }

  ngOnDestroy() {
      this.removeSubscriptions();
  }

  removeSubscriptions() {
      this.events.unsubscribe('product:publishAllCategoriesForShop');
      this.events.unsubscribe('product:noCategoryAvailable');
    //   this.events.unsubscribe('search-engine:productSearchResults');
      this.events.unsubscribe('search-engine:noSearchProductsAvailable');
      this.events.unsubscribe('search-engine:noMoreSearchProducts');
     // this.events.unsubscribe('auth:logoutSuccess');
      //this.events.unsubscribe('multi-region:publishActiveStatus');
      //this.events.unsubscribe('multi-region:publishAllActiveRegions');
      this.cartSub.unsubscribe();
  }



  async initializeSubscriptions() {
      const pickDrop = this.configService.environment.pickDrop;
      const pickupDropSettings: any = await this.pickDropService.getPickDropSettings();
      console.log('settingss:', pickupDropSettings);
      if (pickupDropSettings && 'active' in pickupDropSettings && pickDrop) {
          this.pickDropActive = pickupDropSettings.active;
      }
      /* this.events.subscribe('multi-region:publishActiveStatus', (data) => {
           if (data) {
               this.multiRegion = data.active;
               if (this.multiRegion) {
                   this.events.publish('multi-region:getAllActiveRegions');
               }
           }
       });
       this.events.subscribe('multi-region:publishAllActiveRegions', (regions) => {
           if (regions.length) {
               this.regions = regions;
               //this.checkUserRegion();
           }
       });*/

      this.cartSub = this.cartService.getCartProductsListener().subscribe((cartProducts) => {
          this.cartLength = cartProducts.length;
          this.cartProducts = cartProducts;
          this.cartTotalPrice = this.cartService.getCartPrice(cartProducts);
      });



      this.events.subscribe('product:publishAllCategoriesForShop', (categories) => {
          this.categories = categories;
      });

      this.events.publish('product:getAllCategoriesForShop');
      setTimeout(() => {
          if (this.categories.length < 1) {
              this.events.publish('product:getAllCategoriesForShop');
          }
      }, 2000);
      this.events.subscribe('product:noCategoryAvailable', () => { });
     /* this.events.subscribe('auth:logoutSuccess', () => {
          this.loginStatus = false;
      })*/



      this.events.publish('product:getAllCategoriesForShop');

      
  }

  subscribeSearch() {
      // search subs...
      this.events.subscribe('search-engine:productSearchResults', async (products) => {
            for (let product of products) {
                product = await this.prepareProductData(product);
            }
            this.displaySearchResult = true;
            this.algoliaProducts = products;
            this.showSearchLoader = false;
            this.showNoProducts = false;
          //// console.log('products', this.algoliaProducts);
      });
      this.events.subscribe('search-engine:noSearchProductsAvailable', () => {
          this.showSearchLoader = false;
          this.showNoProducts = true;
      });
      this.events.subscribe('search-engine:noMoreSearchProducts', () => {
          this.noMoreProducts = true;
          this.showSearchLoader = false;
      });
  }

  async prepareProductData(product: any) {
    const wishlistProducts = await this.storage.get('wishlistProducts');
    const subRole = await this.storage.get('userSubRole');
    const userId = await this.storage.get('uid');
    const data = {
        wishlistProducts,
        subRole,
        userId,
        product,
        cartProducts: this.cartProducts
    }
    const updatedProduct = await this.sharedService.prepareProductData(data);
    return updatedProduct;
}

  fireSearchQuery() {
      if (this.userService.userId === '' && !this.isOpenSearch) {
          this.openLoginModal()
      } else {
          clearTimeout(this.typingTimer);
          if (this.searchText.length > 2 && (this.isOpenSearch || this.userService.getUserId())) {
              this.typingTimer = setTimeout(() => {
                  //// console.log('in fireSearchQuery...');
                  this.showSearchLoader = true;
                  this.showNoProducts = false;
                  if (!this.searchsubscribed) {
                      this.subscribeSearch();
                      this.searchsubscribed = true;
                  }
                  this.events.publish('search-engine:alogoliaSearchProducts', this.searchText, 0, 'new_search');
              }, this.doneTypingInterval);

          }
      }

  }
  showSearchResult() {
      console.log('showSearchResult')
      if (this.userService.userId === '' && !this.isOpenSearch) {
          this.openLoginModal()
      } else {
          this.displaySearchResult = true;
          console.log(this.displaySearchResult)
      }
  }

  async loadMoreProducts() {
      this.page = this.page + 1;
      this.events.publish('search-engine:alogoliaSearchProducts', this.searchText, this.page, 'existing_search');
  }

  urlName(pname: string) {
      return encodeURL(pname);
  }

  goToPage(page: string) {
      this.router.navigate([page]);
  }
  goToCart() {
      if (this.loginStatus) {
          this.router.navigate(['user-cart']);
      } else {
          this.openLoginModal()
      }
  }

  gotoWishlist() {
      if (this.loginStatus) {
          this.router.navigate(['user-wishlist']);
      } else {
          this.openLoginModal()
      }
  }

  logout() {
      this.headerUtilsService.logout();
      //this.events.publish('auth:logout');
      //this.events.publish('makeUnreadAdminMsgsZero');
  }

  async navigateCategory(category) {

      if (this.activeMenu == category.id) {
          this.hideMenu = true;
      } else {
          console.log(category)
          let cname = encodeURL(category.name);

          if (category.sublist && category.sublist.length) {
              // this.sharedService.manageExclusiveCategories(category.isExclusive || false, category.id, 'parentCategory');
              this.router.navigate([`shop-subcategories/${cname}/${category.id}`]);
          } else {
              // let exclusiveObj = await this.storage.get('exclusiveObj');
              // const isExclusive = exclusiveObj.categoryType === 'parentCategory' && exclusiveObj.exclusivity ? false : category.isExclusive;
              // this.sharedService.manageExclusiveCategories(isExclusive || false, category.id, 'subCategory');
              this.router.navigate([`shop/category/${cname}/${category.id}`]);
          }

      }
  }

  onClickBrand(brand) {

      if (this.activeMenu == brand.id) {
          this.hideMenu = true;
      } else {
          let brandName = encodeURL(brand.name);
          this.router.navigate([`shop/brand/${brandName}/${brand.id}`]);
      }
  }

  enableMenu() {
      this.hideMenu = false;

  }

  onClickSubcat(catg, subCatg) {
      // this.sharedService.manageExclusiveCategories(subCatg.isExclusive || false, subCatg.id, 'subCategory');
      this.router.navigate(['/shop/category/', this.urlSlug(catg.name), catg.id, this.urlSlug(subCatg.name), subCatg.id]);
  }

  urlSlug(value) {
      return encodeURL(value);
  }



  async onClickService(service) {
      const res = await this.sharedService.checkLoginStatus('You must logged in as user to access Services');
      if (res) {
          const navigationExtras: NavigationExtras = {
              state: {
                  serviceData: service
              }
          };
          this.router.navigate(['service-response'], navigationExtras);
      }
  }

  async openLoginModal() {
      this.searchText = '';
      this.utilsService.openLoginModal();
  }

  onClickProduct(pdt: any) {
      const name = encodeURL(pdt.prodName);
      if (pdt.ptype === 'child') {
          this.router.navigate([`product-details/${name}/${pdt.parentId}/option/${pdt.objectID}`]);
      } else {
          this.router.navigate([`product-details/${name}/${pdt.objectID}`]);
      }

      this.removeSubscriptions();
      this.searchsubscribed = false;
      this.searchText = '';
  }

  checkPdtStock(pdt) {
      let isOutOfStock = false;
      if (!pdt.isPriceList) {
          if (pdt.productQty === '0' && pdt.stopWhenNoQty) {
              isOutOfStock = true;
          }
      } else {
          if (pdt.stopWhenNoQty) {
              for (let pl of pdt.priceList) {
                  if (pl.totalQuantity !== '0') {
                      isOutOfStock = false;
                      break;
                  } else {
                      isOutOfStock = true;
                  }
              }
          }
      }
      return isOutOfStock;
  }

  openChat() {
      if (this.userService.userId != '') {
          this.openChatModal();
      } else {
          this.openLoginModal();
      }
  }

  async openChatModal() {
      const modal = await this.modalController.create({
          component: ChatBotPage,
          cssClass: "chat-modal",
          showBackdrop: false,
          backdropDismiss: false
      });

      return await modal.present();
  }

  async openSelectLanguageModal() {
      const modal = await this.modalController.create({
          component: SelectLanguagePage,
          cssClass: 'custom-modal',
      });

      await modal.present();

  }

  async setExclusive(category) {
      if (category.sublist && category.sublist.length) {
          // this.sharedService.manageExclusiveCategories(category.isExclusive || false, category.id, 'parentCategory');
      } else {
          // let exclusiveObj = await this.storage.get('exclusiveObj');
          // const isExclusive = exclusiveObj.categoryType === 'parentCategory' && exclusiveObj.exclusivity ? false : category.isExclusive;
          // this.sharedService.manageExclusiveCategories(isExclusive || false, category.id, 'subCategory');
      }
  }

  onClickVendor(product) {
      this.router.navigate([`vendor-info/${encodeURL(product.vendorName)}/${product.vendorId}`]);
  }

  async checkVendorSettingsForLocation() {
      if(this.configService.environment.multiVendor) {
          await this.vendorService.getMultiVendorSettings();
      }
  }

  openUserPlaceModal(action: string) {
      this.vendorService.openPlaceModal(action);
  }

  isVendorBasedOnKm() {
      return this.vendorService.vendorSettings.vendorBasedOnKm; 
  }

    showVendorInfo(vendorName) {
        return this.vendorService.vendorSettings.showVendorInfo && vendorName;
    }

    goToSearchResults() {
        if(this.searchText) {
            this.navCtrl.navigateRoot([`search-results/${encodeURL(this.searchText)}`])
        }
    }
}
